const MFlags = {
  subscriptionAndPaymentMethodDisabled: false,
  preventScheduleTestRunEnabled: false,
  allowBetaUserForFeatureRCAEnabled: false,
  testRunReportFilterEnhancementEnabled: false,
  testCloudDisableSCDeviceResourceByOrg: false,
  testRunReportFilterEnhancementPhase2Enabled: false,
  e2eTestGenerationEnabled: false,
  g5Editor: false,
  profileFilterEnhancementEnabled: false,
  testPerformanceForReportAndAnalyticsEnabled: false,
  shareFilterResultByUrlEnabled: false,
  displayTestCaseNumberEnabled: false,
  testCloudUploadSampleNativeAppEnabled: false,
  fixPercentageTestRunChart: false,
  fixTimeRangeInChartEnable: false,
  testRunHideHeaderEnable: false,
  identifierForProductTrackingEnabled: false,
  g5DevMode: false,
  g5CreateSampleTestCaseEnabled: false,
  testCloudG5TestSuiteEnabled: false,
  addMoreInformationToTestCaseDetailEnabled: false,
  onboardingChecklistEnabled: false,
  onboardingChecklistEnhancementEnabled: false,
  hideKatOneOnboardingSteps: false,
  hideKatalonStudioOnboardingSteps: false,
  collapseTestRunsReportChartEnabled: false,
  convertToTypeScriptEnabled: false,
  dashboardAIEnabled: false,
  dashboardAIPhase2Enabled: false,
  videoPlayerEnabled: false,
  removeDuplicatedSearchRequest: false,
  raJiraIntegrationEnhancementPhase2Enabled: false,
  fixReleaseExecutionStatusBarEnabled: false,
  changeStageAndStatusExecutionRule: false,
  instantRunTestCasesEnabled: false,
  updateDeleteTestOpsTestSuiteDialog: false,
  externalSeverityMigrationEnabled: false,
  fixTestRunReportPageSizeEnabled: false,
  removeGitSupportForCloudStudioEnabled: false,
  jiraIssueLinkingCreatingEnabled: false,
  changeImportingStatusEnabled: false,
  automationRuleEnabled: false,
  preventNamingTestOpsInTestSuiteFoldersEnabled: false,
  hideResultActionWhenParsingNotCompletedEnabled: false,
  removeSearchQueryInputInDynamicFilterEnabled: false,
  filterUnresolvedTestResultEnabled: false,
  jiraSlackIntegrationEnabled: false,
  openLastAccessedFolderTestCase: false,
  removeAgentOnboardingStepEnabled: false,
  viewSuggestedDefectEnabled: false,
  refreshMetricCardEnabled: false,
  modifyDefectListInTestResultDetailEnabled: false,
  testResultListEnhancementEnabled: false,
  revampFailedTestResultEnabled: false,
  enhanceDropdownFieldBehaviorEnabled: false,
  dailyExecutionEmailEnabled: false,
  genAISettingsAccountLevelEnabled: false,
  useRAMicroFrontEndEnabled: false,
  htmlInjection: true,
  atgCheckFeaturePermission: false,
  editTestCaseData: false,
  testCloudDisableTCFromScheduleDialog: false,
  filterOrganizationsOnOrganizationMenuByAccount: false,
  vstSettingsFromAccountLevel: false,
  planningG3GA: false,
  hideManualTestG2Enabled: false,
  disableCreateNewOrganization: false,
  improveTestRunDetailPerformanceEnabled: false,
  isCombinedPdfReportEnabled: false,
  redirectOrganizationSelectEnabled: false,

  parse(configs) {
    Object.entries(configs).forEach(([key, value]) => {
      MFlags[key] = value;
    });
  },
};

export default MFlags;
